export const RS_TURBO_DOUBLE_CHANCE = {
  title: "TURBO",
  dataTable: [
    // ----- DC TURBO 2 -----
    {
      titleTable: "TURBO DOUBLE CHANCE",
      descriptionTable: "DRAW FIRST [first] NUMBERS AND [last] NUMBERS",
      descriptionKeyFirst: "5",
      descriptionKeyLast: "5",
      colspan: "3",
      dataTableHeader: [
        { title: "DC TURBO [number]", key: "2", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "first [number] numbers",
          last: "last [number] numbers",
          keyNumber: "",
          keyFirst: "5",
          keyLast: "5",
        },
        {
          number: "[number] numbers",
          first: "1,500",
          last: "1,100",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC TURBO 3 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC TURBO [number]", key: "3", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "first [number] numbers",
          last: "last [number] numbers",
          keyNumber: "",
          keyFirst: "5",
          keyLast: "5",
        },
        {
          number: "[number] numbers",
          first: "520",
          last: "320",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC TURBO 4 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC TURBO [number]", key: "4", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "first [number] numbers",
          last: "last [number] numbers",
          keyNumber: "",
          keyFirst: "5",
          keyLast: "5",
        },
        {
          number: "[number] numbers",
          first: "260",
          last: "160",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
    // ----- DC TURBO 5 -----
    {
      titleTable: "",
      descriptionTable: "",
      descriptionKeyFirst: "",
      descriptionKeyLast: "",
      colspan: "3",
      dataTableHeader: [
        { title: "DC TURBO [number]", key: "5", colspan: "" },
        { title: "MULTIPLIER", key: "", colspan: "2" },
      ],
      dataTableContent: [
        {
          number: "",
          first: "first [number] numbers",
          last: "last [number] numbers",
          keyNumber: "",
          keyFirst: "5",
          keyLast: "5",
        },
        {
          number: "[number] numbers",
          first: "185",
          last: "125",
          keyNumber: "2",
          keyFirst: "",
          keyLast: "",
        },
      ],
    },
  ],
};
